import React, { useEffect, useRef, useState } from "react";
import { HelpCircle } from "lucide-react";
import { helpPopupStyles } from "./help-tooltip.styles";

interface HelpTooltipProps {
  description: string;
}

export function HelpTooltip({ description }: HelpTooltipProps) {
  const [showHelp, setShowHelp] = useState(false);
  const helpRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!showHelp) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (helpRef.current && !helpRef.current.contains(event.target as Node)) {
        setShowHelp(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showHelp]);

  return (
    <div style={{ position: "relative", display: "flex" }} ref={helpRef}>
      <button
        type="button"
        onClick={() => setShowHelp(!showHelp)}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "var(--colors-primary)",
          opacity: showHelp ? 1 : 0.6,
          padding: "2px",
          display: "flex",
        }}
        title="Show info"
      >
        <HelpCircle size={14} />
      </button>
      {showHelp && <div className={helpPopupStyles}>{description}</div>}
    </div>
  );
}
